export default {
    autoatendimento: 'Veus Self Attendance',
    home: {
        bemvindo: 'Welcome to',
        cadastrar: 'Register',
        orcamento: 'Consultar Estimate'
    },
    cadastro: {
        title: 'Register Form',
        obrigatorio: 'Field %s is mandatory!',

        steps: {
            verificacao: 'Verification',
            dados: 'Info',
            dadospessoais: 'Personal Info',
            endereco: 'Address',
            documentos: 'Documents',
            anterior: 'Back',
            proximo: 'Next',
            enviar: 'Send'
        },
        unidade: 'Hospital',
        documento: 'Passport Number',

        nome: 'Complete Name',
        email: 'Email',
        telefone: 'Cellphone',
        sexo: 'Gender',
        masculino: 'Male',
        feminino: 'Female',
        nascimento: 'Birthday',
        //
        cep: 'Zip Code',
        estado: 'State',
        cidade: 'City',
        bairro: 'District',
        logradouro: 'Address',
        numero: 'Number',
        complemento: 'Complement',

        identidade: 'ID Card',
        documentos: 'TISS Guides / Exam Request Health plan Card',

        documento_invalido: 'Invalid Passport Number!',
        campos_invalidos: 'Invalid Fields',
        mensagem: {
            sucesso: 'Successful registration!',
            erro: 'Error when registering!'
        }
    },
    orcamentos: {
        consultar: 'Consult',
        meusorcamentos: 'My Estimates'
    },
    qr: {
        obrigado: 'Thank you for using',
        explicacao: 'Use this QRCode to check your estimate and in your service',
        parafazer: 'To make your appointment',
        cliqueaqui: 'Click Here',
        faleconosco: 'or call us on',
        voltar: 'Back to Home',
        erro: 'Erro on load yout request'
    },
    show: {
        aguardando: 'Processing estimate!',
        atualizar: 'Update',
        orcamento_sucesso: 'Budget Generated Successfully!',
        funcionalidade_construcao: 'Functionality in Construction'
    }
}
